exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-widget=AemUniformsEcho] .inlet-wrapp .group-vertical fieldset > div > div {\n  display: block;\n  margin: auto;\n}\n", ""]);

// exports
